module.exports = __webpack_public_path__ + "static/media/BLUSH_6943.c6f804eb.jpg";